<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col
        lg="12"
        style="display:block; text-align:center;padding-bottom:15px;font-size:1.2em;"
        v-if="total > 0"
      >
        <span style="padding:5px; float:left">Total Records: <b>{{total}}</b></span>
        <b-button
          class="download-button"
          variant="primary"
          size="lg"
          @click="downloadExcel();"
        >
          <div style="display:inline-block;" v-if="loading2019" class="loading">
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce bouncing2">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>

          <i v-else class="fa fa-file-excel-o" aria-hidden="true"></i>
          Download
        </b-button>


      </b-col>
      <b-col lg="12">
        <c-table :table-data="data" :fields="fields" :caption="title"></c-table>
        <div v-show="loading" class="sk-double-bounce">
          <div class="sk-child sk-double-bounce1"></div>
          <div class="sk-child sk-double-bounce2"></div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cTable from "./Table.vue";
import Vue from 'vue'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

export default {
  props: [ "type", "date_from", "date_to" ],
  components: { cTable },
  data: () => {
    return {
      excelDownload: "",
      loading2019: false,
      dataType: '',
      loadingExcel: false,
      dateFromParam: "",
      dateToParam: "",
      title: "",
      loading: true,
      data: [],
      total: 0,
      fields: [
        { key: "fnsid", label: "FNSID", sortable: true },
        { key: "location", label: "Location"},
        { key: "originalRa", label: "Original RA" },
        { key: "fnsra", label: "New RA" },
        { key: "prodMake", label: "Make" },
        { key: "prodModel", label: "Model"},
        { key: "serNum", label: "Serial Number" },
        { key: "recvDate", label: "Received" },
        { key: "shipDate", label: "Shipped" },
        { key: "defChar", label: "Item Master#" },
        { key: "newSa", label: "NewSAP MM" },
      ]
    };
  },
  methods: {
    fetchData() {
      let params = {};
      params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam
      };
      this.$http
        .get("api/tables/alldata-" + this.dataType + ".php", { params })
        .then(
          res => {
            this.data = res.data.records;
            console.log(res.data);
            if(res.data.message) {
              this.loading = false;
            }
            this.total = res.data.records.length;
            this.loading = false;
          },
          err => {
            this.loading = false;
            console.log(err);
          }
        );
    },
     downloadExcel() {
      this.loading2019 = true;
      let params = {};
      params = {
        date_from: this.dateFromParam,
        date_to: this.dateToParam,
        xml: "true",
      };
      this.$http
        .get("api/tables/alldata-" + this.dataType + ".php", {
          params,
          responseType: "blob"
        })
        .then(
          res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "TableReport.xlsx");
            document.body.appendChild(link);
            link.click();
            this.loading2019 = false;
          },
          err => {
            this.loading2019 = false;
            console.log(err);
          }
        );
    },
  },
  mounted() {
    this.title = "Overall Data - " + this.type.toUpperCase()
    this.dateFromParam = this.date_from
    this.dateToParam = this.date_to
    this.dataType = this.type
    this.fetchData()
  }
}
</script>

<style >
.download-button {
  display: inline-block;
  margin: auto;
  float: right;
  font-weight: 500;
  padding: 0.7em;
  font-size: 0.9em;
  border-radius: 0.3rem;
  color: white;
  background: #20a8d8;
}
.bouncing2 {
  height: 20px !important;
  width: 20px !important;
  line-height: 55px;
  margin: auto;
}
.download-button:hover {
  text-decoration: none !important;
  color: white;
}
.fa-file-excel-o {
  font-size: 1em;
  color: #ffffff68;
  transform: rotate(30deg);
  padding-right: 0.5em;
}
</style>
